/* eslint-disable */
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
// Componentes
import DropDown from '../../Components/DropDown';
import GenericTable from 'Pages/reports/[submodules]/employees/components/GenericTable/GenericTable';
import RoleSwitch from './Components/RoleSwitch';
import Search from '../../Components/Search';
import SideBarContainer from 'Containers/SideBarContainer';
import Title from '../../Components/Title';
// Material
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
// Hooks personalizados
import useDropDown from './Hooks/useDropdown';
import useRolesApi from 'Hooks/useRolesApi';
import useTranslation from '../../Hooks/useTranslation';
//Estilos
import { colors } from 'Constants/Colors';
import style from './style';

const { searchContainer, findContainer, tableContainer } = style;

export default function Roles() {
  const history = useHistory();
  const { t } = useTranslation();

  const { data } = useRolesApi({ init: true });
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    setRoles(data);
  }, [data]);

  const { setSearch, setStatus, filteredRoles } = useDropDown(roles);

  const methods = [setStatus];
  const options = [[t('Generic.Active'), t('Generic.Inactive')]];
  const titles = [t('Roles.Status')];

  /**
   * @description Editar rol verficia primero si el rol seleccinado no es
   * Administrador ni Empleado. En caso de que no, manda el id del rol a editar.
   * @param {Object} role - Objeto rol que contiene el id.
   */
  const editRole = role => {
    if (role.name === 'Administrador' || role.name === 'Empleado') {
      alert(t('Roles.NoEditAdmin'));
    } else {
      history.push({
        pathname: `/roles/${role.id}`,
        state: {
          update: true,
          role: role.id,
        },
      });
    }
  };

  return (
    <SideBarContainer>
      {/* Título y botón */}
      <Title
        title={t('Roles.Roles')}
        textButton={t('Roles.AddRole')}
        disabledButton={false}
        eventButton={() => history.push('/roles/crear')}
      />

      {/* Búsqueda y filtro */}
      <div style={searchContainer}>
        <div style={{ width: '40%' }}>
          <Search setData={setSearch} placeholder={t('Generic.Search')} />
        </div>
        <div style={findContainer} className="flex">
          {titles.map((title, index) => (
            <DropDown key={title + index} title={title} options={options[index]} setData={methods[index]} />
          ))}
        </div>
      </div>

      {/* Tabla de datos */}
      <div style={tableContainer}>
        <GenericTable
          columns={[
            { id: 'name', label: t('Roles.RoleName'), align: 'center' },
            { id: 'totalUsers', label: t('Roles.UserCount'), align: 'center' },
            { id: 'statusSwitch', label: t('Roles.Status'), align: 'center' },
            { id: 'edit', label: '', align: 'center' },
          ]}
          rows={filteredRoles.map(role => ({
            id: role.id,
            name: role.name,
            totalUsers: role.totalUsers,
            statusSwitch: <RoleSwitch role={role} setRoles={setRoles} t={t} editRole={editRole} allRoles={roles} />,
            edit:
              role.name === 'Administrador' || role.name === 'Empleado' || role.active === false ? (
                <Button disabled={true}>
                  <EditIcon
                    style={{
                      color: colors.GRAY_HR,
                    }}
                  />
                </Button>
              ) : (
                <Button onClick={() => editRole(role)}>
                  <EditIcon
                    style={{
                      color: colors.GREEN_LEAF,
                    }}
                  />
                </Button>
              ),
          }))}
          // loading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
